var map = {
	"./academy-dev.js": 198,
	"./academy-local.js": 199,
	"./academy-preprod.js": 200,
	"./academy.js": 197,
	"./dev-v2.js": 202,
	"./dev.js": 201,
	"./index.js": 47,
	"./local.js": 203,
	"./preprod.js": 204,
	"./prod.js": 205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;